<template>
    <span class="reblogBtn">
        <a v-if="isLoading" href="#"><icon icon="sync" spin :size="size" /></a>
        <a v-else-if="wasReblogged" href="#" class="text-success"><icon icon="check-circle" :size="size" /></a>
        <a v-else href="#" @click.prevent="pushBtn()"><icon icon="retweet" :size="size" /></a>
    </span>
</template>

<script>

    import Icon from '../Icon';

    export default {
        name: 'ReblogButton',
        props: {
            post: {default: Object},
            size: {type: String, default: "1x"}
        },
        data() {
            return {
                isLoading: false,
                wasReblogged: false
            }
        },
        created() {
        },
        computed:{
            blogs(){
                return this.$store.state.user.blogs;
            },
            isLoggedIn(){
                return this.$store.getters['user/isLoggedIn'];
            }
        },
        methods: {
            pushBtn(){
                if(!this.isLoggedIn){
                    this.$bus.$emit('error', 'Please login for reblogging!');
                    return;
                }
                if(!this.blogs || this.blogs.length < 1){
                    this.$bus.$emit('error', "You don't have any Blogs yet!");
                    return;
                }
                if(this.blogs.length>1){
                    this.$bus.$emit('blogPicker', (blog)=>{
                        this.reblog(blog);
                    })
                } else {
                    this.reblog(this.blogs[0]);
                }
            },
            reblog(blog){
                this.isLoading = true;
                this.$api.reblog(blog.url, this.post._id)
                    .then((res)=> {
                        this.isLoading = false;
                        this.wasReblogged = true;
                        this.$bus.$emit('success', "Post was reblogged!");
                        setTimeout(()=>{this.wasReblogged=false},3000);
                    })
                    .catch((err)=>{
                        this.isLoading = false;
                    });
            }
        },
        components:{
            Icon
        }
    }
</script>

<style lang="sass" scoped>
    .reblogBtn
        position: relative

        .sublist
            position: absolute
            right: 0

            a
                display: block
                background-color: rgba(0,0,0,.5)
                padding: 4px 12px
                text-decoration: none
                color: #FFF
                transition: all .3s ease-out
                text-shadow: none
                white-space: nowrap
                max-width: 320px
                overflow: hidden
                text-overflow: ellipsis
                margin-bottom: 1px

                &:hover
                    background: rgba(255,255,255,.8)
                    color: #000


</style>



// WEBPACK FOOTER //
// src/components/ui/buttons/ReblogButton.vue